// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"1c998198","255":"2e42447e","453":"68693753"}[chunkId] + ".chunk.js";
};